import { Outlet, useNavigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { selectLensEditorFieldAiConfigs, selectLensEditorFormFieldsMap } from "redux/slices/lensEditor";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { AppRoutes } from "AppRoutes";
import { useEffect } from "react";

const ProfileGenerationTestsRoute = () => {
  const { lensId, fieldId } = useParamNumbers(["lensId", "fieldId"]);
  const fieldAiConfigs = useAppSelector(selectLensEditorFieldAiConfigs);
  const fieldMap = useAppSelector(selectLensEditorFormFieldsMap);
  const navigate = useNavigate();
  const firstField = fieldAiConfigs.toSorted((a, b) => {
    const sortLast = { rank: Number.MAX_SAFE_INTEGER };
    const f1 = fieldMap.get(a.fieldId) || sortLast;
    const f2 = fieldMap.get(b.fieldId) || sortLast;
    return f1.rank - f2.rank;
  })[0];
  const fieldIdFallback = fieldId || firstField?.fieldId;

  if (lensId === undefined || fieldIdFallback === undefined) {
    return null;
  }

  useEffect(() => {
    if (fieldId === undefined) navigate(AppRoutes.aiTestsField(lensId, fieldIdFallback));
  }, []);

  return <Outlet />;
};

export default ProfileGenerationTestsRoute;
